import { render, staticRenderFns } from "./JobAndCampaignSelectorWrapper.vue?vue&type=template&id=630a5f72&scoped=true"
import script from "./JobAndCampaignSelectorWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./JobAndCampaignSelectorWrapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobAndCampaignSelectorWrapper.vue?vue&type=style&index=0&id=630a5f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a5f72",
  null
  
)

export default component.exports